import { Breadcrumbs } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { DealEditor } from "~/components/common/deals/new/DealEditor";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { PATH } from "~/pages/deals";
import Styles from "./Page.module.scss";

export const Page: React.FC = () => (
	<DefaultV2>
		<div className={Styles.PageTop}>
			<Breadcrumbs
				items={[
					{ as: Link, href: PATH, label: "案件一覧" },
					{ label: "案件追加" }
				]}
			/>
			<h1 className={Styles.Title}>案件追加</h1>
		</div>
		<DealEditor />
	</DefaultV2>
);
